export const PixelFontFamily = 'PixelFont'
export const YELLOW1 = '#DB8505'
export const YELLOW2 = '#FFC100'
